import React, { useState, useEffect } from 'react';
import { signupApi, ossApi } from '../Api';
import { BeatLoader } from "react-spinners";

const ScheduleNavigation = () => {
    const [jobStatus, setJobStatus] = useState(null);
    const [token, setToken] = useState(null);
    const [hasFailed, setHasFailed] = useState(false);
    const POLL_INTERVAL = 5000; // Poll every 5 seconds
    const TARGET_STATUS = 'Success';
  
    useEffect(() => {
      let isPollingActive = true;
      // Set a timeout to stop polling after 60 seconds
      const stopPollingTimeout = setTimeout(() => {
        console.log('Polling stopped after 60 seconds.');
        isPollingActive = false;
        if(token===null) setHasFailed(true);
      }, 20000);
  
      const pollJobStatus = async () => {
        try {
          // Poll the Laravel API endpoint for job status
          const response = await signupApi.get(
            '/job-status?signup_id=' + window.sessionStorage.getItem('orderID')
          );
          console.log(response);
          const status = response.data.Response.Status.Message;
          setJobStatus(status);
  
          if (!isPollingActive) return;
  
          // Stop polling if the status is 'failed' or 'no'
          if (status === 'failed' || status === 'presale') {
            console.log('Job status is either failed or presale. Stopping poll.');
            isPollingActive = false;
            setHasFailed(true);
            return;
          }
  
          // When status is 'Success', extract ticketID and signupID and call another API
          if (status === TARGET_STATUS) {
            console.log('Job reached target status:', status);
            const { TicketID, SignupID } = response.data.Response.Data; // Adjust keys if necessary
  
            // Make another API call with ticketID and signupID
            try {
              const anotherResponse = await ossApi.get(
                'token?ui=website&SignupID=' +
                  SignupID +
                  '&TicketID=' +
                  TicketID +
                  '&CreatedUserID=33&RequestedFrom=Website'
              );
              console.log('Response from another endpoint:', anotherResponse);
  
              // Assume the token is returned as anotherResponse.data.Response.Data.original.Response.Data
              const token = anotherResponse.data.Response.Data.original.Response.Data;
              setToken(token);
              clearTimeout(stopPollingTimeout);
            } catch (error) {
              console.error('Error calling another endpoint:', error);
            }
  
            isPollingActive = false;
            return;
          }
  
          // If none of the stop conditions are met, schedule the next poll
          if (isPollingActive) {
            setTimeout(pollJobStatus, POLL_INTERVAL);
          }
        } catch (error) {
          console.error('Error fetching job status:', error);
          if (isPollingActive) {
            setTimeout(pollJobStatus, POLL_INTERVAL);
          }
        }
      };
  
      pollJobStatus();
  
      // Cleanup: Stop polling and clear the timeout on component unmount
      return () => {
        isPollingActive = false;
        clearTimeout(stopPollingTimeout);
      };
    }, []);
  
    return (<>
        {hasFailed === false ? (
      <div className='mt-4 mb-4'>
      <h1>{token === null ? "Checking if we can schedule" : "Almost Done!"}</h1>
        <p style={{ margin: "0 auto" }}>{token === null ? "Wait here to see if you can schedule your installation" : "Now, Let's schedule your professional installation appointment"}</p>
        
        <div style={{ textAlign: "center", margin: "0 auto", maxWidth: "300px" }}>
            
            <div className={`rounded-full self-center mt-2 py-2 px-6 cursor-pointer font-bold ${token ? "bg-yellow" : "bg-gray"} text-gray hover:bg-yellow-600 text-2xl`}>
                {token === null ? (
                <div>
                    <BeatLoader
                    className="mx-auto mt-1"
                    size={"1rem"}
                    color={"#FFFFFF"}
                    speedMultiplier={0.75}
                    />
                </div>
                ) : (
                <div onClick={() => window.location.href = `/schedule?token=${token}`}>Schedule Now!</div>
                )}
            </div>
           
        </div>        
       
      </div>
        ) : (
            <div className='mt-4 mb-4'>
                <h1>We need more info</h1>
                <div>We'll reach out shortly to schedule your free professional installation that works best for you.</div>
            </div>)}
    </>);
  };

export default ScheduleNavigation;